export function signedFileName(originalName: string): string {
  const lower = originalName.toLowerCase();
  if (lower.endsWith('.docx')) {
    const base = originalName.slice(0, -5).trim() || 'Dokument';
    return `${base}-signiert.docx`;
  }
  if (lower.endsWith('.pdf')) {
    const base = originalName.slice(0, -4).trim() || 'Dokument';
    return `${base}-signiert.pdf`;
  }
  const base = originalName.replace(/\.[^.]+$/, '').trim() || 'Dokument';
  return `${base}-signiert.pdf`;
}

export function isDocxFileName(name: string): boolean {
  return name.toLowerCase().endsWith('.docx');
}

export function isPdfFileName(name: string): boolean {
  return name.toLowerCase().endsWith('.pdf');
}
